const scrollDown = document.querySelector('#scroll-down-animation');
const homepageBanner = document.querySelector('.homepage-banner');
const nextSibling = homepageBanner?.nextElementSibling?.nextElementSibling;

scrollDown?.addEventListener('click', scrollDownAnimation);

function scrollDownAnimation() {
    nextSibling?.scrollIntoView({ behavior: 'smooth' });
}